import classnames from "classnames";
import * as I from "immutable";
import MobileDetect from "mobile-detect";
import moment from "moment-timezone";
import React from "react";
import round from "lodash.round";

import {
  DATE_FORMAT_DESKTOP,
  DATE_FORMAT_MOBILE,
  ROUTE_UNASSIGNED_LABEL,
} from "config/constants";

export const mobileDetect = new MobileDetect(window.navigator.userAgent);

export const combineDateTime = (value, duration) => {
  return moment(value)
    .add(moment.duration(duration))
    .tz("UTC")
    .format("YYYY-MM-DDTHH:mm:ssZ");
};

export const capitalizeString = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const fieldGroupClassNames = (errors=[]) => {
  return classnames("form-group", {
    "has-error": errors.length > 0,
  });
};

export const formatDuration = (duration, withSeconds=true) => {
  const parts = [duration.hours(), leadingZero(duration.minutes())];
  if (withSeconds) {
    parts.push(leadingZero(duration.seconds()));
  }
  return parts.join(":");
};

export const durationToUnits = (value, unitOfTime) => {
  return value ? round(moment.duration(value).as(unitOfTime)) : null;
};

export const formatPrice = (value, number=0) => {
  return `$${value.toFixed(number)}`;
};

export const getDateFormat = () => {
  return isDesktop() ? DATE_FORMAT_DESKTOP : DATE_FORMAT_MOBILE;
};

export const getGardenerLabel = (item, raw=false) => {
  const name = item.fullName || item.email;
  const inTrainingClass = item.inTraining ? "Trainee" : "";
  const {type} = item;
  const displayColor = item.displayColor ? item.displayColor : "#000000";
  if (type && !raw) {
    return (
      <span
        className={`Gardener ${type} ${inTrainingClass}`}
        key={`gardener-${item.id}`} style={{color:`${displayColor}`}}>
        {name}
      </span>
    );
  }
  return name;
};

export const getRouteFromContext = (context) => {
  const {data} = context;
  let {params: {routeId}} = context;
  routeId = parseInt(routeId, 10);

  const found = data.filter(item => item.id === routeId);
  return found.length ? found[0] : null;
};

export const getRouteLabel = (route, raw=false) => {
  const {assignments} = route;
  if (assignments.isEmpty()) {
    const label = ROUTE_UNASSIGNED_LABEL;
    return [raw ?
      label :
      // eslint-disable-next-line react/jsx-indent
      <span className="GardenerUN" key="gardener-un">{label}</span>,
    ];
  }

  const label = [];

  const nonTrainees = assignments.filter((item) => !item.inTraining);
  nonTrainees.forEach((item, idx) => {
    label.push(getGardenerLabel(item, raw));
    if (idx !== nonTrainees.size - 1) {
      label.push(", ");
    }
  });

  const trainees = assignments.filter((item) => item.inTraining);
  if (trainees.size) {
    label.push(" [");
    trainees.forEach((item, idx) => {
      label.push(getGardenerLabel(item, raw));
      if (idx !== trainees.size - 1) {
        label.push(", ");
      }
    });
    label.push("]");
  }
  return label;
};

export const isCtrlPressed = (evt) => {
  const ctrlKey = isMac() ?
    evt.ctrlKey || evt.metaKey :
    evt.ctrlKey && !evt.metaKey;
  return ctrlKey && !evt.altKey && !evt.shiftKey;
};

export const isDataLoaded = ({data, dataError}, key) => {
  if (key) {
    return data.get(key) && !dataError.get(key);
  }
  return data && !dataError;
};

export const isDesktop = () => {
  return !mobileDetect.phone() && !mobileDetect.mobile() && !mobileDetect.tablet();
};

export const isMac = () => {
  return navigator.platform.slice(0, 3) === "Mac";
};

export const leadingZero = (value) => {
  const valueStr = value.toString();
  return value < 10 ? `0${valueStr}` : valueStr;
};

export const noop = () => {
  // do nothing
};

export const parseApiErrors = (errorResponse) => {
  let errors = I.Map({"non_field_errors": ["Unexpected error from server"]});
  if (errorResponse && errorResponse.status >= 400 && errorResponse.status < 500) {
    errors = I.Map(errorResponse.data);
  }
  return errors;
};

export const splitAddress = (address) => {
  const splitted = address.split(", ");

  let state = "";
  let zipCode = "";
  if (splitted.length > 2 && splitted[2].indexOf(" ") !== -1) {
    [state, zipCode] = splitted[2].split(" ");
  }

  return [splitted[0], splitted[1], state, zipCode];
};

export const swapValue = (fromObj, toObj, key) => {
  const fromValue = fromObj[key];
  const toValue = toObj[key];
  toObj[key] = fromValue;
  fromObj[key] = toValue;
};

export default {
  combineDateTime,
  capitalizeString,
  fieldGroupClassNames,
  formatDuration,
  getDateFormat,
  getRouteFromContext,
  getRouteLabel,
  isCtrlPressed,
  isDesktop,
  isMac,
  leadingZero,
  mobileDetect,
  noop,
  parseApiErrors,
  splitAddress,
  swapValue,
};



/** WEBPACK FOOTER **
 ** ./src/app/utils.js
 **/